import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { getFormattedAge } from '../share-function';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrl: './input.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent {
  @Input() type: string = 'search';
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = 'Type here';
  @Input() maxlength: number | null = null;
  @Input() minlength: number | null = null;
  @Input() disabled: boolean = false;
  @Input() className: string = '';
  @Input() min: string = '';
  @Input() max: string = '';
  @Input() validateReqMsg: string = 'This field is required.';
  @Input() amountLow: string = '';

  @Input() required: boolean = false;
  @Input() model: any;
  @Input() validateNumber: boolean = false;
  @Input() allowDecimal: boolean = false;
  @Input() decimalPlaces: number = 2;
  @Input() loading: boolean = false;
  @Input() isPhoneNumber: boolean = false;
  
  @ViewChild('inputModel', { static: true }) inputModel!: NgModel;
  @Output() keypressEvent = new EventEmitter<KeyboardEvent>();
  @Output() blurEvent = new EventEmitter<void>();

  value: any = '';

  // onChange(value: any) {
  //   // this.value = value; // Update the local value
  //   // Trigger the external change detection mechanism (only if provided)
  //   if (this.onChangeCallback) {
  //     this.onChangeCallback(value); // Call the registered callback (the parent component's binding)
  //   }
  // }
  onChange(value: any) {
    if (this.maxlength && typeof value === 'string' && value.length > this.maxlength) {
      value = value.substring(0, this.maxlength);
    }
    
    this.value = value;

    if (this.onChangeCallback) {
      this.onChangeCallback(value);
    }
  }
  
  //  THE BULLETPROOF ENFORCER:
  // This physically hacks the browser text input field and truncates it instantly,
  // completely bypassing the Myanmar keyboard composition bug.
  onNativeInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    
    // If the user types or pastes past 6, we truncate it instantly 
    // mid-composition, forcing the text box to respect the limit.
    if (this.maxlength && inputElement.value.length > this.maxlength) {
      inputElement.value = inputElement.value.substring(0, this.maxlength);
      this.onChange(inputElement.value); // Syncs it back into your Angular nrcGroup model
    }
  }

  onTouched = () => { };

  // writeValue(value: any): void {
  //   this.value = value;
  //   this.model = value;
  //   // this.inputModel.control.setValue(value); // al changed this on 20250108 because of the  DOM element re-creation. when we used *ngIf & *ngFor
  // }

  writeValue(value: any): void {
    if (this.type === 'date' && value) {
      this.value = this.formatToISODate(value);
    } else {
      this.value = value;
    }
    this.model = value;
  }

  private formatToISODate(value: string): string {
    if (!value || value.includes('-')) return value;

    // Handle "04/01/1958" or "01 Apr 1958"
    const parts = value.includes('/') ? value.split('/') : value.split(' ');
    
    if (value.includes('/')) {
      // MM/DD/YYYY -> YYYY-MM-DD
      return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
    } else if (parts.length === 3) {
      // DD MMM YYYY -> YYYY-MM-DD
      const months: any = { jan:'01', feb:'02', mar:'03', apr:'04', may:'05', jun:'06', jul:'07', aug:'08', sep:'09', oct:'10', nov:'11', dec:'12' };
      const day = parts[0].padStart(2, '0');
      const month = months[parts[1].toLowerCase().substring(0, 3)];
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }
    return value;
  }

  private onChangeCallback: any = () => { };

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn; // Save the provided callback function
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Handle disabled state if needed
  }

  onBlur(event: FocusEvent): void {
    this.blurEvent.emit(); // Emit blur event to parent
  }

  // onKeypress(event: KeyboardEvent): void {
  //   if (this.validateNumber) {
  //     const input = event.target as HTMLInputElement;
  //     const selectionStart = input.selectionStart ?? undefined; // Convert null to undefined
  //     const selectionEnd = input.selectionEnd ?? undefined; // Convert null to undefined
  //     const currentValue = input.value;
  //     const key = event.key;
      
  //     // Allow control keys (backspace, delete, arrows, etc.)
  //     if (event.ctrlKey || event.altKey || event.metaKey || 
  //         key === 'Backspace' || key === 'Delete' || 
  //         key === 'ArrowLeft' || key === 'ArrowRight' || 
  //         key === 'Tab' || key === 'Enter') {
  //       return;
  //     }
  
  //     // Allow decimal point if allowed
  //     if (key === '.' && this.allowDecimal) {
  //       // Prevent multiple decimal points
  //       if (currentValue.includes('.')) {
  //         // Allow if the selection includes the existing decimal point
  //         if (selectionStart !== undefined && selectionEnd !== undefined && 
  //             selectionStart !== selectionEnd && 
  //             currentValue.slice(selectionStart, selectionEnd).includes('.')) {
  //           return;
  //         }
  //         // Allow if cursor is after existing decimal and we're not adding another
  //         if (selectionStart !== undefined && currentValue.indexOf('.') < selectionStart) {
  //           return;
  //         }
  //         event.preventDefault();
  //       }
  //       return;
  //     }
  
  //     // Allow only numbers
  //     if (!/\d/.test(key)) {
  //       event.preventDefault();
  //       return;
  //     }
  
  //     // Handle decimal places limitation
  //     if (this.allowDecimal && this.decimalPlaces) {
  //       const decimalIndex = currentValue.indexOf('.');
  //       if (decimalIndex > -1) {
  //         // Check if we're adding after the decimal point
  //         if (selectionStart !== undefined && selectionStart > decimalIndex) {
  //           // Calculate how many digits after decimal
  //           const digitsAfterDecimal = currentValue.length - decimalIndex - 1;
  //           // If replacing selected text, adjust the count
  //           const replacedLength = selectionEnd !== undefined ? selectionEnd - selectionStart : 0;
  //           const newDigitsAfterDecimal = digitsAfterDecimal - replacedLength + 1;
            
  //           if (newDigitsAfterDecimal > this.decimalPlaces) {
  //             event.preventDefault();
  //             return;
  //           }
  //         }
  //       }
  //     }
  //   }
    

  //   this.onChange(this.value);
  //   this.keypressEvent.emit(event);
  // }
  onKeypress(event: KeyboardEvent): void {
  if (!this.validateNumber) {
    this.onChange(this.value);
    this.keypressEvent.emit(event);
    return;
  }

  const input = event.target as HTMLInputElement;
  const currentValue = input.value;
  const key = event.key;
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;

  // Allow control/navigation keys
  const controlKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'
  ];
  if (event.ctrlKey || event.altKey || event.metaKey || controlKeys.includes(key)) {
    return;
  }

  // Allow only digits and optionally one dot
  const isDigit = /^\d$/.test(key);
  const isDot = key === '.';

  if (!isDigit && !isDot) {
    event.preventDefault();
    return;
  }

  // Handle decimal point (dot) input
  if (isDot) {
    if (!this.allowDecimal) {
      event.preventDefault();
      return;
    }

    const hasDot = currentValue.includes('.');

    // If dot already exists, only allow if user is replacing that exact dot
    if (hasDot) {
      const selectedText = currentValue.slice(selectionStart, selectionEnd);
      const isReplacingDot = selectedText.includes('.');

      if (!isReplacingDot) {
        event.preventDefault(); // Block second dot
        return;
      }
    }

    return;
  }

  // Handle decimal places limitation (only applies after dot)
  if (this.allowDecimal && this.decimalPlaces) {
    const decimalIndex = currentValue.indexOf('.');

    if (decimalIndex > -1 && selectionStart > decimalIndex) {
      const digitsAfterDecimal = currentValue.length - decimalIndex - 1;
      const replacedLength = selectionEnd - selectionStart;
      const newDigitsAfterDecimal = digitsAfterDecimal - replacedLength + 1;

      if (newDigitsAfterDecimal > this.decimalPlaces) {
        event.preventDefault();
        return;
      }
    }
  }

  // All validations passed
  this.onChange(this.value);
  this.keypressEvent.emit(event);
}


  markAsTouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsTouched();
    }
  }

  markAsUntouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsUntouched();
    }
  }

}
